<template>
  <div class="sidebar">

      <nav class="sidebar-nav">
        <ul class="nav">
          <li class="nav-item"  v-if="isKnowledgeOnly() === false">
              <router-link to="/dashboard" exact class="nav-link">
                  <i class="icon-speedometer"></i> Dashboard
              </router-link>
          </li>
          <li class="nav-item"  v-if="isKnowledgeOnly() === false && this.permissions.indexOf('company_management') >= 0">
              <router-link :to="{path: '/schools', query: { page: 1 }}" exact class="nav-link">
                  <i class="fa fa-university"></i> Schools
              </router-link>
          </li>
          <li class="nav-item"  v-if="isKnowledgeOnly() === false">
              <router-link :to="{path: '/classes', query: { page: 1 }}" exact class="nav-link">
                  <i class="icon-notebook icons"></i> Classes
              </router-link>
          </li>
          <li class="nav-item"  v-if="isKnowledgeOnly() === false">
              <router-link :to="{path: '/classes/calendar', query: { page: 1 }}" exact class="nav-link">
                  <i class="icon-calendar icons"></i> Class Calendar
              </router-link>
          </li>
          <li class="nav-item"  v-if="isKnowledgeOnly() === false && this.permissions.indexOf('company_management') >= 0">
              <router-link :to="{path: '/class-types', query: { page: 1 }}" exact class="nav-link">
                  <i class="fa fa-book"></i> Class Types
              </router-link>
          </li>
           <li class="nav-item"  v-if="isKnowledgeOnly() === false">
              <router-link :to="{path: '/teacher-directory', query: { page: 1 }}" exact class="nav-link">
                  <i class="icon-eyeglass icons"></i> Teacher Directory
              </router-link>
          </li>
          <li class="nav-item" v-if="this.permissions.indexOf('company_management') >= 0 && isKnowledgeOnly() === false">
              <router-link :to="{path: '/clients', query: { page: 1 }}" exact class="nav-link">
                  <i class="fa fa-book"></i> Clients
              </router-link>
          </li>
          <li class="nav-item nav-dropdown"  v-if="isKnowledgeOnly() === false">
              <a href="#" class="nav-link nav-dropdown-toggle"><i class="fa fa-money"></i>Expenses</a>
              <ul class="nav-dropdown-items">
                <li class="nav-item">
                  <router-link :to="{path: '/expenses', query: { page: 1 }}" exact class="nav-link">
                      <i class="fa fa-money"></i> Expenses
                  </router-link>
                </li>
                <li class="nav-item" v-if="this.permissions.indexOf('approve_expense') >= 0">
                  <router-link :to="{path: '/expenses/approve', query: { page: 1 }}" exact class="nav-link">
                      <i class="fa fa-check-square-o"></i> Approve Expenses
                  </router-link>
                </li>
              </ul>
          </li>
          <li class="nav-item nav-dropdown" v-if="this.permissions.indexOf('company_management') >= 0 && isKnowledgeOnly() === false"  >
            <a href="#" class="nav-link nav-dropdown-toggle"><i class="icon-wrench"></i>Settings</a>
            <ul class="nav-dropdown-items">
              <li class="nav-item"  v-if="this.permissions.indexOf('company_management') >= 0">
                <router-link :to="{path: '/settings', query: { page: 1 }}" class="nav-link">
                    <i class="fa fa-cog"></i> Company Settings
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{path: '/users?page=1'}" class="nav-link">
                    <i class="fa fa-users"></i> Manage Users
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{path: '/users/teacher?page=1'}" class="nav-link">
                    <i class="fa fa-user"></i> Manage Teachers
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{path: '/settings/email-settings?page=1'}" class="nav-link">
                    <i class="fa fa-envelope"></i> Email Settings
                </router-link>
              </li>


            </ul>
        </li>
        <li class="nav-item nav-dropdown"  v-if="isKnowledgeOnly() === false">
            <a href="#" class="nav-link nav-dropdown-toggle"><i class="fa fa-newspaper-o"></i>Reports</a>
            <ul class="nav-dropdown-items">
              <li class="nav-item" v-if="this.permissions.indexOf('company_management') >= 0">
                <router-link :to="{path: '/reports/teacher?page=1'}" class="nav-link">
                    <i class="fa fa-users"></i> Teacher
                </router-link>
              </li>
              <li class="nav-item" v-if="this.permissions.indexOf('company_management') >= 0">
                <router-link :to="{path: '/reports/student?page=1'}" class="nav-link">
                    <i class="fa fa-user"></i> Student
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{path: '/teacher-salary?page=1'}" class="nav-link">
                    <i class="fa fa-money"></i> Teacher Salary
                </router-link>
              </li>
              <li class="nav-item" v-if="this.permissions.indexOf('view_revenue_report') >= 0">
                <router-link :to="{path: '/reports/revenue?page=1'}" class="nav-link">
                    <i class="fa fa-money"></i> Revenue
                </router-link>
              </li>
              <li class="nav-item" v-if="this.permissions.indexOf('view_expense_report') >= 0">
                <router-link :to="{path: '/reports/expense?page=1'}" class="nav-link">
                    <i class="fa fa-money"></i> Expense
                </router-link>
              </li>
            </ul>
        </li>
        <li class="nav-item nav-dropdown" v-if="this.permissions.indexOf('company_management') >= 0 && isKnowledgeOnly() === false">
            <a href="#" class="nav-link nav-dropdown-toggle"><i class="fa fa-sticky-note-o"></i>Invoices</a>
            <ul class="nav-dropdown-items">
              <li class="nav-item">
                <router-link :to="{path: '/invoices?page=1'}" class="nav-link">
                    <i class="fa fa-sticky-note"></i> List of Invoices
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{path: '/invoices/create'}" class="nav-link"  v-if="this.permissions.indexOf('create_invoice') >= 0">
                    <i class="fa fa-plus"></i> Generate Invoice
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{path: '/quotes?page=1'}" class="nav-link">
                    <i class="fa fa-file-text-o"></i> Quotes
                </router-link>
              </li>
            </ul>
        </li>
        <li class="nav-item" v-if="isKnowledgeOnly() === false">
          <router-link :to="{path: '/credit-notes?page=1'}" class="nav-link"  v-if="this.permissions.indexOf('company_management') >= 0">
              <i class="fa fa-credit-card"></i> Credit Notes
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{path: '/knowledge?page=1'}" class="nav-link"  v-if="is_knowledge_admin === true || is_knowledge === true || is_admin === true">
              <i class="fa fa-book"></i> Knowledge
          </router-link>
        </li>

          <li class="nav-item" v-if="isAdmin() || is_knowledge_admin === true">
            <router-link :to="{path: '/tags?page=1'}" class="nav-link">
                <i class="fa fa-users"></i> Manage Tags
            </router-link>
          </li>

          <li class="nav-item" v-if="isAdmin() || is_knowledge_admin === true">
          <router-link :to="{path: '/documents?page=1'}" class="nav-link">
              <i class="fa fa-users"></i> Manage Documents
          </router-link>
        </li>


        </ul>
      </nav>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    data () {
      return {
        is_admin: false,
        is_manager: false,
        is_client: false,
        is_teacher: false,
        is_knowledge: false,
        is_knowledge_admin: false,
        roles: []
      }
    },
    created () {
      this.roles = (localStorage.getItem('session_roles')) ? JSON.parse(localStorage.getItem('session_roles')) : []
      var vue = this
      _.each(this.roles, function (item) {
        if (item.name === 'admin') {
          vue.is_admin = true
        }
        if (item.name === 'manager') {
          vue.is_manager = true
        }
        if (item.name === 'client') {
          vue.is_client = true
        }
        if (item.name === 'teacher') {
          vue.is_teacher = true
        }
        if (item.name === 'knowledge') {
          vue.is_knowledge = true
        }
        if (item.name === 'knowledge_admin') {
          vue.is_knowledge_admin = true
        }
      })
    },
    computed: {
      ...mapGetters({
        permissions: 'permissions',
        userroles: 'userroles'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue